import type { Epic } from 'redux-observable';
import initializer from '@atlassian/jira-common-tangerine/src/state/initiate.tsx';
import errorHandlerReduxMiddleware from '@atlassian/jira-errors-handling/src/utils/redux-middleware.tsx';
import fetchServicedeskPortal, { type ServicedeskPortalService } from '../services/index.tsx';
import type { Action } from './actions.tsx';
import rootReducer, { defaultState } from './reducer.tsx';
import type { State } from './types.tsx';

export const APP_ID = 'project-settings-apps.servicedesk-portal-link' as const;

type Dependencies = {
	fetchServicedeskPortal: ServicedeskPortalService;
};

const rootEpicDependencies: Dependencies = {
	fetchServicedeskPortal,
};

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (rootEpic: Epic<Action, State>) =>
	initializer<State, Action, Dependencies>({
		appName: 'project-settings/servicedesk-portal-link',
		// @ts-expect-error - TS2322 - Type '(state: State | undefined, action: FetchServicedeskPortalSuccessAction) => State' is not assignable to type 'Reducer<State>'.
		rootReducer,
		rootEpic,
		rootEpicDependencies,
		initialState: defaultState,
		middlewares: [errorHandlerReduxMiddleware(APP_ID)],
	});
